/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetSocialConnectionsConnectionsForStationQueryResponse, GetSocialConnectionsConnectionsForStationPathParams } from "../models/GetSocialConnectionsConnectionsForStation";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getSocialConnectionsConnectionsForStation } from "../axios/getSocialConnectionsConnectionsForStation";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getSocialConnectionsConnectionsForStationQueryKey = (station: GetSocialConnectionsConnectionsForStationPathParams["station"]) => ["web-app-bff-api", { url: '/social-connections/:station', params: {station:station} }] as const

export type GetSocialConnectionsConnectionsForStationQueryKey = ReturnType<typeof getSocialConnectionsConnectionsForStationQueryKey>

export function getSocialConnectionsConnectionsForStationQueryOptions(station: GetSocialConnectionsConnectionsForStationPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getSocialConnectionsConnectionsForStationQueryKey(station)
        return queryOptions<GetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, GetSocialConnectionsConnectionsForStationQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return getSocialConnectionsConnectionsForStation(station, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get all connection states for a station
 * {@link /social-connections/:station}
 */
export function useGetSocialConnectionsConnectionsForStation<TData = GetSocialConnectionsConnectionsForStationQueryResponse, TQueryData = GetSocialConnectionsConnectionsForStationQueryResponse, TQueryKey extends QueryKey = GetSocialConnectionsConnectionsForStationQueryKey>(station: GetSocialConnectionsConnectionsForStationPathParams["station"], options: 
{
  query?: Partial<QueryObserverOptions<GetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getSocialConnectionsConnectionsForStationQueryKey(station)
         

         const query = useQuery({
          ...getSocialConnectionsConnectionsForStationQueryOptions(station, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}